var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScribble1 = function SvgScribble1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m3.63 8.37 4.694-4.694c.926-.926 2.44-.912 3.383.03.942.943.956 2.458.03 3.383L3.69 15.135c-.925.926-.912 2.44.03 3.383.943.942 2.458.956 3.383.03l8.046-8.046c.926-.925 2.44-.912 3.383.03.942.943.957 2.457.03 3.383l-3.017 3.018c-1.779 1.779.685 4.654 2.67 3.903.552-.208 1.036-.585 1.598-.768l1.169-.38",
    clipRule: "evenodd"
  })));
};
export default SvgScribble1;